import React, { useContext } from 'react';
import { UserContext } from '@incentivegames/ig-frontend-common/lib/contexts/userContext';
import LoginRevealButton from 'components/LoginRevealButton/LoginRevealButton';
import HowItWorks from 'components/HowItWorks';
import RestrictedContainer from 'components/RestrictedContainer';
import routes from 'constants/routes';
import useIGTranslation from 'hooks/useIGTranslation';
import './HomeView.scss';
import Footer from 'components/Footer/Footer';
import { IViewDataProps } from 'interfaces/gameInterfaces';
import { HomeFunctions } from '../homeFunctions';
import useDynamicImage from 'hooks/useDynamicImage';
import config from 'theme/config';

export interface IHomeViewProps {
  data: IViewDataProps;
}

const HomeView = (props: IHomeViewProps) => {
  const { t } = useIGTranslation();
  const userContext = useContext(UserContext);
  const fileName = HomeFunctions.getLogoName();
  const logoImage = useDynamicImage({
    name: fileName,
    fileType: 'svg'
  });
  const region = process.env.REACT_APP_REGION;
  const showTermsAndConditions = config.settings.termsAndConditionsDisplayRegions.includes(region!);

  const envLanguage = process.env.REACT_APP_LANGUAGE;
  const envRegion = process.env.REACT_APP_REGION;

  const isBulgarian = envLanguage === 'bg' || envRegion === 'bg';

  const homeLogoClassName = isBulgarian ? 'home__logo-bg' : 'home__logo';
  const freeToPlayClassName = isBulgarian ? 'home__free-to-play-bg' : 'home__free-to-play';

  return (
    <RestrictedContainer>
      <div className="home">
        <img src={logoImage!} alt={`${fileName} game badge`} className={homeLogoClassName} data-testid={`${fileName}-image`} />
        <div className={freeToPlayClassName} />
        <div className="home__reveal-prizes">
          <div>{t('reveal-players-to')}</div>
          <div className="home__reveal-prizes--bold">{t('win-cash-prizes')}</div>
        </div>
        <HowItWorks translationKeys={['how-it-works-text-1', 'how-it-works-text-2']} />
        {props.data.error ? (
          <div className="home__error">{t(props.data.error)}</div>
        ) : (
          <LoginRevealButton
            pathName={routes.FIVES.route}
            searchLocation={window.location.search}
            token={userContext.user.token}
            tokenState={props.data.tokenState}
            handleStartPlayingClick={props.data.handleStartPlayingClick}
            roundStartTime={props.data.roundStartTime}
          />
        )}

        <Footer handleHowToPlayClick={props.data.handleHowToPlayClick} tokenState={props.data.tokenState} roundStartTime={props.data.roundStartTime}></Footer>
        {showTermsAndConditions && <div className="home__termsandconditions">{t(`tcs-significant-conditions-${region}`)}</div>}
      </div>
    </RestrictedContainer>
  );
};

export default HomeView;
